import { PageLoader } from '@optools/components/loading/page-loader';
import { useConfigQuery } from '@optools/store/configApiSlice';

export function ConfigProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isUninitialized } = useConfigQuery();
  if (isUninitialized || isLoading || !data) return <PageLoader withDelay />;
  return children;
}
